import { ICategory } from "../../api/category/CategoriesApi";
import { OrderDetail } from "../document/Document";
import { InventoryValue } from "../manufacturer/Manufacturer";
import { Product } from "../product/Product";

export class Category {

  public categoryName?: string;
  public categoryCode?: string;
  public niche?: string;
  /** @deprecated use aGp instead */
  public a_gp?: number;
  public aGp?: number;
  /** @deprecated use bGp instead */
  public b_gp?: number;
  public bGp?: number;
  /** @deprecated use cGp instead */
  public c_gp?: number;
  public cGp?: number;
  /** @deprecated use dGp instead */
  public d_gp?: number;
  public dGp?: number;
  /** @deprecated use costGp instead */
  public cost_gp?: number;
  public costGp?: number;
  public leadTime?: string;
  public minimumOrder?: string;
  public weeksOfStocking?: string;
  public inventoryValue?: InventoryValue[];
  public products?: Product[];
  public openOrders?: OrderDetail[];
  public starred?: boolean;
  public autoReorder?: boolean;
  public qualificationRequired?: boolean;

  public static convertFrom(source: ICategory): Category {
    const category = new Category();

    category.categoryName = source.CategoryName;
    category.categoryCode = source.CategoryCode;
    category.niche = source.Niche;
    category.a_gp = source.A_GP;
    category.aGp = source.A_GP;
    category.b_gp = source.B_GP;
    category.bGp = source.B_GP;
    category.c_gp = source.C_GP;
    category.cGp = source.C_GP;
    category.d_gp = source.D_GP;
    category.dGp = source.D_GP;
    category.cost_gp = source.Cost_GP;
    category.costGp = source.Cost_GP;
    category.leadTime = String(source.LeadTime);
    category.minimumOrder = String(source.MinimumOrder);
    category.weeksOfStocking = String(source.WeeksOfStocking);
    category.starred = source.Starred;
    category.autoReorder = source.AutoReorder;
    category.qualificationRequired = source.QualificationRequired;

    if (source.InventoryValue)
      category.inventoryValue = source.InventoryValue.map(InventoryValue.convertFrom);

    if (source.Products)
      category.products = source.Products.map(Product.convertFrom);

    if (source.OpenOrders)
      category.openOrders = source.OpenOrders.map(o => OrderDetail.convertFrom(o));

    return category;
  }
}
